import campaignModel from "../../../models/planogram/campaign.model";
import ViewBase from "../../view-base.view";
import imageNotAvailable from "StaticFolder/images/image_not_available.png"
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import paginationComponent from "../../../components/pagination/pagination.component";

export default function CampaignDetail() {
  ViewBase.call(this);
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };
  let _campaignName = "";
  let _campaignId = "";
  let fixtureList = [];
  const filters = {
    siteCode: ""
  }
  let pagination = structuredClone(DEFAULT_PAGINATION);

  const DEFAULT_SELECTED_FIXTURE = {
    fixtureId: '',
    base64String: '',
    fixtureName: '',
    position: []
  }
  let selectedFixture = structuredClone(DEFAULT_SELECTED_FIXTURE);

  let paginatedPosition = []

  let goBackList = () => { };
 
  let siteList = []

  const getCampaignSiteList = () => {
    const params = {
      campaignID: _campaignId,
    }
    campaignModel.getCampaignStoreList(params)
      .then(result => {
        siteList = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getCampaignDetails = (selectSite) => {
    this.showLoading();
    const params = {
      siteID: selectSite,
      campaignId: _campaignId
    }
    campaignModel.getCampaignDetails(params).then((result) => {
      fixtureList = result.fixture;
    }).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    });
  }

  const handleFixturePhotoClick = (data) => {
    selectedFixture.fixtureId = data.fixtureId;
    selectedFixture.position = data.position;
    selectedFixture.fixtureName = data.fixtureName;
    selectedFixture.base64String = data.base64String;
    pagination.totalItems = data.position.length;
    pagination.pageIndex = 1;
    handlePaginate(data.position, 1, 10);
  }

  const handlePaginate = (position, pageIndex, pageSize) => {
    const startIndex = (pageIndex - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    paginatedPosition = position.slice(startIndex, endIndex);
  }

  return {
    oninit: ({ attrs: { onGoBackList, campaignId, campaignName } }) => {
      if (onGoBackList) {
        goBackList = onGoBackList;
      }

      if (campaignId) {
        _campaignId = campaignId;
      }
      if (campaignName) {
        _campaignName = campaignName
      }
      getCampaignSiteList()
    },
    view: (vnode) => {
      return [
        m('.row.g-2',
          _campaignName != "" &&
          m('.w-100',
            m('h2',
              m('i.bi.bi-arrow-left.cursor-pointer', {
                onclick: goBackList
              }),
              `[View Uploaded Images] ${_campaignName}`
            ),
          ),
          m('.card', m('.card-body',
            m('.row',
              m('label.col-sm-1.col-form-label[for="statusSelect"]', this.getText("LT00000169", "Store")),
              m('.col-sm-4', m(SingleSelectComponent, {
                id: 'statusSelect',
                items: siteList,
                allowEmpty: false,
                keyOnly: true,
                selectedItem: filters.siteCode,
                onSelect: (selectedItem) => {
                  filters.siteCode = selectedItem;
                  selectedFixture = structuredClone(DEFAULT_SELECTED_FIXTURE);
                  getCampaignDetails(selectedItem);
                }
              }))
            )
          )),
          fixtureList?.length > 0 && m('.row', m('.d-flex.flex-nowrap.g-3.p-0', { style: { "overflow-x": "auto" } },
            [fixtureList.map((data) =>
              m('div.me-2', {
                style: { "min-width": "180px", "max-width": "180px", "text-align": "center" },
              },
                m('img.img-thumbnail.me-2.mb-2.custom-img-thumbnail', {
                  class: selectedFixture.fixtureId === data.fixtureId ? 'custom-img-thumbnail-active' : "",
                  src: data.base64String || imageNotAvailable, alt: "fixture photo",
                  onclick: () => handleFixturePhotoClick(data)
                }),
                m('p', {style: { "word-wrap": "break-word","padding-right": "10px" }}, m('strong', data.fixtureName))
              ))
            ])
          ),
          selectedFixture.fixtureId && m('.row', m('.d-flex.justify-content-between.g-3.p-0',
            m('img.img-fluid.img-thumbnail', { src: selectedFixture.base64String || imageNotAvailable, alt: "fixture photo", style: { width: "65%", height: "auto" } }),
            m('.card.ms-2',
              { style: { "width": "35%" } },
              m('.card-body',
                m('.row.g-2',
                  m('.col-12',
                    m('h4', selectedFixture.fixtureName),
                    m('.table-responsive',
                      m('table.table.table-sm',
                        m('thead',
                          m('tr.align-middle.center',
                            m('th', this.getText('LT00001206', 'Position')),
                            m('th', this.getText('LT00000748', 'Model Code'))
                          )
                        ),
                        m('tbody',
                        paginatedPosition.length === 0 &&
                          m("tr",
                            { class: "align-middle" },
                            m("td",
                              { colspan: "100%" },
                              this.getText("EM00000141", "No records found.")
                            )
                          ),
                          paginatedPosition.length > 0 &&
                          paginatedPosition.map((data,) => {
                            return m('tr.align-middle.center',
                              m('td.p-2', m('span.cursor-text', data.position)),
                              m('td.p-2', m('span.cursor-text', data.modelCode)),
                            )
                          }))
                      )
                    )
                  )
                ),
                m('.col-12', m(paginationComponent,
                  {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    footerNeed: false,
                    showPageSize: false,
                    onPageChanged: (pageIndex) => {
                      pagination.pageIndex = pageIndex;
                      handlePaginate(selectedFixture.position, pageIndex, 10)
                    },
                    // onPageSizeChanged: (_, pageSize) => {
                    //   pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                    //   pagination.pageSize = pageSize;
                    //   // getFixtureList();
                    // }
                  }
                ))
              )
            )
          ),
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}